import React, { useState, useEffect } from 'react'
import { Button, Card, Tabs, Tab } from 'react-bootstrap'
import Utils from 'common/Utils'
import API from 'common/logic/API'
import BigSpinner from 'common/components/BigSpinner'
import Title from "common/components/Title"
import ExpenseByTagBarChart from 'application/budget/ExpenseByTagBarChart'
import ExpenseByTagTable from 'application/budget/report/ExpenseByTagTable'
import TransferBetweenMonthsWorkflow from 'application/budget/report/TransferBetweenMonthsWorkflow'
import * as Icons from 'react-bootstrap-icons'
import MonthOfYear from 'common/logic/MonthOfYear'

interface Props {
    query: Record<string, string>
    url: string
}

function Report(_props: Props) {
    const calculateMonth = () => {
        const query = new URLSearchParams(window.location.search)
        const fromParam = query.get("month") || ""
        return MonthOfYear.parse(fromParam) || MonthOfYear.now()
    }

    const [month, setMonth] = useState<MonthOfYear>(calculateMonth)
    const [tagBreakdown, setTagBreakdown] = useState<any>(null)
    const [showTransferWorkflow, setShowTransferWorkflow] = useState(false)

    const fetchData = (m: MonthOfYear) => {
        setTagBreakdown(null)
        API.get(`/expense-report/breakdown-by-tag/${m}`)
            .then((response: any) => {
                setTagBreakdown(response.data)
            }).catch((error: any) => {
                console.error(error.message)
            })
    }

    useEffect(() => {
        fetchData(month)
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const changeDates = (m: MonthOfYear) => {
        Utils.pushUrlWithParams({ month: m.toString() })
        setMonth(m)
        fetchData(m)
    }

    if (!tagBreakdown) {
        return <BigSpinner />
    }

    const nextMonth = month.nextMonth()
    const prevMonth = month.previousMonth()

    const prevButton = <Button
        onClick={() => changeDates(prevMonth)}
        variant="link"
        className="prev"><Icons.ChevronDoubleLeft /></Button>

    const nextButton = <Button
        onClick={() => changeDates(nextMonth)}
        variant="link"
        className="next"><Icons.ChevronDoubleRight /></Button>

    const title = <Title title="Monthly expense report" />
    const currencies = Object.keys(tagBreakdown.total)
    const transferAmount = currencies.length === 1 ? Number(tagBreakdown.total[currencies[0]]) : 0
    const transferWorkflow = showTransferWorkflow
        ? <TransferBetweenMonthsWorkflow
            month={month}
            amount={transferAmount}
            onSuccess={() => {
                setShowTransferWorkflow(false)
                fetchData(month)
            }}
        />
        : null

    return (
        <>
            {title}
            <p>{prevButton} {month.toString()} {nextButton}</p>
            <Button variant="link" onClick={() => setShowTransferWorkflow(true)}>
                Transfer to next month
            </Button>
            {transferWorkflow}
            <Tabs mountOnEnter={true} unmountOnExit={true}>
                <Tab eventKey="table" title="Table">
                    <Card>
                        <ExpenseByTagTable entries={tagBreakdown.entries} total={tagBreakdown.total} month={month} />
                    </Card>
                </Tab>
                <Tab eventKey="graph" title="Graph">
                    <Card>
                        <ExpenseByTagBarChart data={tagBreakdown.entries} />
                    </Card>
                </Tab>
            </Tabs>
        </>
    )
}

export default Report
